import { backendRequest } from "./backendApi";
import exceptionService from "./exceptionService";
const call = async (path: string, body: any, context: string) => {
  const r = await backendRequest<boolean>(path, body);
  if (r.error) exceptionService.logError(r.error, context);
  return r.data === true;
};
const subscriptionService = {
  async fetchActiveSubscription(_userId: string) {
    const r = await backendRequest("/subscriptions/active");
    if (r.error) exceptionService.logError(r.error, "subscriptionService.fetchActiveSubscription");
    return r;
  },
  async insertSubscription(
    _userId: string,
    subscriptionId: string,
    stripeCustomerId: string
  ): Promise<Boolean> {
    return call(
      "/subscriptions/insert",
      { subscriptionId, stripeCustomerId },
      "subscriptionService.insertSubscription"
    );
  },
  async cancelSubscription(
    _userId: string,
    subscriptionId: string,
    cancelDate?: Date
  ): Promise<Boolean> {
    return call(
      "/subscriptions/cancel",
      { subscriptionId, cancelDate },
      "subscriptionService.cancelSubscription"
    );
  },
  async resolveFailedPayment(failedPaymentId: number, subscriptionId: string): Promise<Boolean> {
    return call(
      "/subscriptions/resolve-payment",
      { failedPaymentId, subscriptionId },
      "subscriptionService.resolveFailedPayment"
    );
  },
};
export default subscriptionService;
